import {Component, h} from "preact";
import styles from './style.module.scss';
import {Variant} from "../../models/product";
import {i18nService} from "../../services/i18n-service";

export interface Props {
    variant: Variant;
}

export default class ProductTag extends Component<Props> {
    render() {
        const variant = this.props.variant;
        let key = '';

        if (variant.comingSoon) {
            key = 'tag_coming_soon';
        } else if (variant.sale) {
            key = 'tag_sale';
        } else if (variant.newIn) {
            key = 'tag_new_in';
        } else if (variant.highlight) {
            key = 'tag_highlight';
        } else {
            return null;
        }

        const text = i18nService.translate(key).toLocaleUpperCase();

        const isSale = variant.sale && !variant.comingSoon;
        const isHighlight = !variant.comingSoon && !variant.sale && !variant.newIn && variant.highlight;

        return (
            <div
                class={`${styles.tag} ${isSale ? styles.red : ''}`}>{text}</div>
        )
    }
}